import { useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import Page from '@/components/content/Page'
import { Translation } from '@/components/i18n/Translation'
import Error from '@/components/util/feedback/Error'
import LoaderCircle from '@/components/util/LoaderCircle'
import {
  fetchDevicePolicyPrices,
  getError,
  getIsDataLoaded,
  getIsPending,
} from '@/ducks/devicePolicyReducer'

import DevicePolicyPriceList from './DevicePolicyPriceList'

const DevicePolicies = () => {
  const dispatch = useDispatch()

  const error = useSelector(getError)
  const isPending = useSelector(getIsPending)
  const iIsDataLoaded = useSelector(getIsDataLoaded)

  useEffect(() => {
    // @ts-ignore
    dispatch(fetchDevicePolicyPrices())
  }, [])

  return (
    <Page>
      <h1>
        <Translation id="Device Policy Prices" />
      </h1>

      {error && <Error textId={error} />}

      {isPending && !iIsDataLoaded ? <LoaderCircle /> : <DevicePolicyPriceList />}
    </Page>
  )
}

export default DevicePolicies
